import { lazy } from "react"

export const Ration = lazy(() => import("./ration"))
